<template>
  <Modal
    v-if="!embedded"
    :value="value"
    :title="modalTitle"
    class-name="vc-add-resource-modal"
    width="560"
    :footer-hide="true"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
    @input="$emit('input', $event)"
  >
    <add-tts-resource-fields :form="form" :providers="providers" />
    <div class="vc-add-resource-footer">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" class="vc-add-resource-confirm" :loading="submitting" @click="handleConfirm">
        确认
      </Button>
    </div>
  </Modal>
  <div v-else class="vc-add-resource-embedded">
    <add-tts-resource-fields :form="form" :providers="providers" />
    <div class="vc-add-resource-footer">
      <Button type="primary" class="vc-add-resource-confirm" :loading="submitting" @click="handleConfirm">
        确认
      </Button>
    </div>
  </div>
</template>

<script>
import AddTtsResourceFields from './AddTtsResourceFields.vue'
import { TTS_RESOURCE_PROVIDERS } from '../../utils/tripleAccessHelpers'

const createEmptyForm = () => ({
  name: '',
  provider: TTS_RESOURCE_PROVIDERS[0] || 'Minimax',
  group_id: '',
  key: '',
  description: '',
})

export default {
  name: 'AddTtsResourceModal',
  components: { AddTtsResourceFields },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      providers: TTS_RESOURCE_PROVIDERS,
      form: createEmptyForm(),
      submitting: false,
    }
  },
  computed: {
    isEditMode() {
      return !!(this.resource && this.resource.id)
    },
    modalTitle() {
      return this.isEditMode ? '编辑资源' : '添加资源'
    },
  },
  watch: {
    resource: {
      immediate: true,
      handler(val) {
        if (this.embedded) {
          this.fillFormFromResource(val)
        }
      },
    },
  },
  methods: {
    fillFormFromResource(resource) {
      if (!resource || typeof resource !== 'object') {
        this.form = createEmptyForm()
        return
      }
      this.form = {
        name: String(resource.name != null ? resource.name : ''),
        provider: String(resource.provider != null ? resource.provider : '').trim()
          || TTS_RESOURCE_PROVIDERS[0]
          || 'Minimax',
        group_id: String(resource.group_id != null ? resource.group_id : ''),
        key: String(resource.key != null ? resource.key : ''),
        description: String(resource.description != null ? resource.description : ''),
      }
    },
    resetForm() {
      this.form = createEmptyForm()
      this.submitting = false
    },
    onVisibleChange(visible) {
      if (visible) {
        this.fillFormFromResource(this.resource)
        this.submitting = false
      }
    },
    handleCancel() {
      this.$emit('input', false)
    },
    validateForm() {
      const name = String(this.form.name != null ? this.form.name : '').trim()
      const provider = String(this.form.provider != null ? this.form.provider : '').trim()
      const groupId = String(this.form.group_id != null ? this.form.group_id : '').trim()
      const key = String(this.form.key != null ? this.form.key : '').trim()
      const description = String(this.form.description != null ? this.form.description : '').trim()
      if (!name) {
        this.$Message.warning('请填写资源名称')
        return null
      }
      if (!provider) {
        this.$Message.warning('请选择供应商')
        return null
      }
      if (!groupId) {
        this.$Message.warning('请填写 group_id')
        return null
      }
      if (!key) {
        this.$Message.warning('请填写 key')
        return null
      }
      if (!description) {
        this.$Message.warning('请填写描述')
        return null
      }
      const payload = { name, provider, group_id: groupId, key, description }
      if (this.isEditMode) {
        payload.id = String(this.resource.id).trim()
      }
      return payload
    },
    handleConfirm() {
      const payload = this.validateForm()
      if (!payload) return
      this.submitting = true
      this.$emit('confirm', payload)
      this.submitting = false
      if (this.embedded && !this.isEditMode) {
        this.resetForm()
      } else if (!this.embedded) {
        this.$emit('input', false)
      }
    },
  },
}
</script>

<style lang="scss">
.vc-add-resource-modal {
  .ivu-modal-header {
    background: linear-gradient(180deg, #eef5ff 0%, #fff 100%);
    border-bottom: none;
    padding: 18px 24px 12px;
  }

  .ivu-modal-body {
    padding: 8px 24px 20px;
  }
}
</style>

<style lang="scss" scoped>
@import './shared.scss';

.vc-add-resource-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 4px;
}

.vc-add-resource-confirm {
  min-width: 88px;
}
</style>
